import React from 'react'
import { AppDataTable } from '@components'
import { useExportConnectionsTableData } from 'Pages/Admin/ExportConnections/@hooks'
import { Skeleton } from '@mui/material'
import { booleanColumn, multiColumn, singleColumn } from 'Pages/Admin/ExportConnections/Table/columns'
import { ButtonSeeker, IconSeeker } from '@ui-seeker/core'
import { isOpenCreateSftpUserModal } from 'Pages/Admin/ExportConnections/@signals'
import CreateSftpUserModal from 'Pages/Admin/ExportConnections/CreateSftpUserModal'
import SftpPasswordModal from 'Pages/Admin/ExportConnections/SftpPasswordModal'

const singleFields = [
	{ value: 'nameUser', label: 'User Name' },
	{ value: 'protocol', label: 'Protocol' },
	{ value: 'serverConnection', label: 'Server Connection' },
	{ value: 'portConnection', label: 'Port Connection' },
	{ value: 'userConnection', label: 'User Connection' },
	{ value: 'passwordConnection', label: 'Password Connection' },
	{ value: 'specificExportPath', label: 'Export Path' },
	{ value: 'fileFormat', label: 'File Format' },
]
const multiFields = [
	{ value: 'excludedFields', label: 'Excluded Fields' },
	{ value: 'filterFields', label: 'Filtered Fields' },
]

const booleanFields = [
	{ value: 'isCompanyRow', label: 'Company' },
	{ value: 'compressFileZip', label: 'Zip' },
	{ value: 'compressFileGzip', label: 'GZip' },
]

export default function ExportConnectionsTable() {

	const { data, isLoading } = useExportConnectionsTableData()

	if (isLoading) return <Skeleton variant="rectangular" height={600}/>

	return <>
		<AppDataTable
			title="Export Connections"
			options={{
				search: true,
				viewColumns: true,
				customToolbar: () => <ButtonSeeker
					startIcon={<IconSeeker icon="plus"/>}
					onClick={() => isOpenCreateSftpUserModal.value = true}
				>
					Create SFTP User
				</ButtonSeeker>,
			}}
			data={data}
			columns={[
				...singleFields.map(e => singleColumn(e)),
				...multiFields.map(e => multiColumn(e)),
				...booleanFields.reduce((acc, e) => [...acc, ...booleanColumn(e)], []),
			]}
		/>
		<CreateSftpUserModal/>
		<SftpPasswordModal/>
	</>
}